'use client';
import React from 'react';
import { GetContent20Response, ArticlePagePropertiesModel } from '@/client';
import Flicking from '@egjs/react-flicking';
import '@egjs/react-flicking/dist/flicking.css';
import { ResponsiveImage } from '@/components';

const TestCarousel = ({ data }: { data: GetContent20Response }) => {
  return (
    <Flicking horizontal preventDefaultOnDrag>
      {data?.items.map((card) => {
        const article = card.properties as ArticlePagePropertiesModel;
        return (
          <div className="img-items relative mx-auto aspect-video w-full" key={card.id}>
            {article?.promoImage && (
              <>
                <ResponsiveImage
                  image={article.promoImage[0]}
                  widths={{ xs: 238, md: 402, lg: 760, xl: 1360, xxl: 1520 }}
                  heights={{ xs: 158, md: 268, lg: 507, xl: 765, xxl: 855 }}
                  className="almafa h-full w-full object-cover"
                />
                <div className="absolute left-0 top-0 rounded-br-3xl bg-black/50 p-6">
                  <h2 className="text-2xl text-white">{article?.promoTitle}</h2>
                </div>
              </>
            )}
          </div>
        );
      })}
    </Flicking>
  );
};

export default TestCarousel;
